import React = require('react')
import { getLangFromUrl } from './history.mod'
const { useEffect, useRef, useImperativeHandle, forwardRef, useState } = React

interface RecaptchaProps {
  onVerify: (token: string | null) => void
}

export interface RecaptchaHandle {
  reset: () => void
}

declare global {
  interface Window {
    grecaptcha: any
    onloadCallback: () => void
  }
}

export const RecaptchaV2 = forwardRef<RecaptchaHandle, RecaptchaProps>(({ onVerify }, ref) => {
  const recaptchaRef = useRef<HTMLDivElement>(null)

  const [widgetId, setWidgetId] = useState<number | null>(null)

  useEffect(() => {
    const lang = getLangFromUrl()
    const scriptSrc = `https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=${lang}`

    window.onloadCallback = () => {
      if (recaptchaRef.current && widgetId === null && window.grecaptcha && typeof window.grecaptcha.render == 'function') {
        const newWidgetId = window.grecaptcha.render(recaptchaRef.current, {
          sitekey: process.env.RECAPTCHA_SITE_KEY,
          callback: onVerify,
          'expired-callback': () => onVerify(null),
          'error-callback': () => onVerify(null)
        })
        setWidgetId(newWidgetId)
      }
    }

    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script')
      script.src = scriptSrc
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    }

    if (window.grecaptcha) {
      window.onloadCallback()
    }
  }, [onVerify, widgetId])

  useImperativeHandle(ref, () => ({
    reset: () => {
      if (window.grecaptcha && widgetId !== null) {
        window.grecaptcha.reset(widgetId)
        onVerify(null)
      }
    }
  }))

  return <div ref={recaptchaRef} />
})